import { put, call, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import { toast } from "react-toastify";
import {
  ADD_SERVICE,
  EDIT_SERVICE,
  GET_SERVICES,
  GET_SERVICE_BY_ID,
  REMOVE_SERVICE,
} from "../../services/ApiCalls";

function* getServicesSaga({ payload, callBack }) {
  try {
    const response = yield call(GET_SERVICES, payload);
    if (response.data.status == "success") {
      yield put(ACTION.getServicesSuccess(response?.data));
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.getServicesFail(error));
    }
  } catch (error) {
    yield put(ACTION.getServicesFail(error));
  }
}

function* removeServicesSaga({ payload, callBack }) {
  try {
    const response = yield call(REMOVE_SERVICE, payload);
    if (response.data.status === "success") {
      yield put(ACTION.removeServiceSuccess());
      toast.success(response?.data?.message);
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.removeServiceFail());
    }
  } catch (error) {
    yield put(ACTION.removeServiceFail());
  }
}
function* addServicesSaga({ payload, callBack }) {
  try {
    const response = yield call(ADD_SERVICE, payload);
    if (response.data.status === "success") {
      toast.success(response?.data?.message);
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
    }
  } catch (error) {
    toast.error(error);
  }
}

function* editServicesSaga({ payload, callBack }) {
  try {
    const response = yield call(EDIT_SERVICE, payload);
    if (response.data.status === "success") {
     toast.success(response?.data?.message);
     callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      callBack && callBack();
    }
  } catch (error) {
    toast.error(error);
  }
}

function* getServiceDataByIdSaga({ payload, callBack }) {
  try {
    const response = yield call(GET_SERVICE_BY_ID, payload);
    if (response.data.status === "success") {
      yield put(ACTION.getServicesByIdSuccess(response?.data?.data));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (error) {
    toast.error(error);
  }
}

function* serviceSaga() {
  yield takeEvery(CONST.GET_SERVICES, getServicesSaga);
  yield takeEvery(CONST.REMOVE_SERVICE, removeServicesSaga);
  yield takeEvery(CONST.ADD_SERVICE, addServicesSaga);
  yield takeEvery(CONST.GET_SERVICES_BY_ID, getServiceDataByIdSaga);
  yield takeEvery(CONST.EDIT_SERVICE, editServicesSaga);
}

export default serviceSaga;
